import { Nothing, isSomething } from "nothing-mock";

export default {
    window: typeof window !== "undefined" ? window : Nothing,
    document: typeof document !== "undefined" ? document : Nothing,
    isDefined: isSomething
};



// WEBPACK FOOTER //
// ./src/managers/Dom.js